export const SBAFooter=()=>{
    const year= new Date().getFullYear();
    return <footer class="px-3 sbaFooter">
    <p class="py-2 m-0 text-center"> &copy;<span className="yearFooter me-1"> {year} </span>
        Asset Edge. All rights reserved.
        </p>
</footer>
}